import React from 'react';
import FolderCommentThread from './FolderCommentThread';
import FolderCommentThreadContainer, {
  OwnProps,
} from './FolderCommentThread.container';

export default FolderCommentThreadContainer(
  FolderCommentThread
) as React.ComponentType<OwnProps>;
